module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Parsed data from your csv file for importing to object "), _c('b', [_vm._v(_vm._s(_vm.objName))])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('b-loading', {
    attrs: {
      "is-full-page": false,
      "active": _vm.loading,
      "can-cancel": false
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.length) ? _c('div', [_c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v("CSV parsing errors:")]), _vm._v(" "), _c('ol', {
    staticClass: "notification is-danger"
  }, _vm._l((_vm.errors), function(err, errIndx) {
    return _c('li', {
      key: errIndx
    }, [_vm._v("\n            " + _vm._s(err.description) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.importErrors.length) ? _c('div', [_c('p', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Parsed data saving errors:")]), _vm._v(" "), _c('ol', {
    staticClass: "notification is-danger"
  }, _vm._l((_vm.importErrors), function(err, errIndx) {
    return _c('li', {
      key: errIndx
    }, [_vm._v("\n            " + _vm._s(err.description) + "\n          ")])
  })), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (!_vm.errors.length) ? _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-fifth csv-column"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n              Configurations\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.resultFields), function(conf, confIndx) {
    return _c('li', {
      key: confIndx
    }, [_c('a', {
      attrs: {
        "href": "#" + confIndx
      }
    }, [_vm._v(_vm._s(confIndx))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "column csv-column"
  }, _vm._l((_vm.resultFields), function(conf, confIndx) {
    return _c('div', {
      key: confIndx,
      staticClass: "box",
      attrs: {
        "label": confIndx
      }
    }, [_c('a', {
      attrs: {
        "name": confIndx
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "title is-3"
    }, [_vm._v(_vm._s(confIndx))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-5 has-text-centered"
    }, [_vm._v("Configuration fields:")]), _vm._v(" "), _c('b-table', {
      attrs: {
        "data": conf.fields
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(props) {
          return [_c('b-table-column', {
            attrs: {
              "label": "Field name",
              "field": "name",
              "width": "40"
            }
          }, [_vm._v("\n                  " + _vm._s(props.row.name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
            attrs: {
              "label": "Default value",
              "field": "edit",
              "width": "40"
            }
          }, [_vm._v("\n                  " + _vm._s(props.row.value) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
            attrs: {
              "label": "Edit by customer",
              "field": "edit",
              "width": "40",
              "centered": ""
            }
          }, [(props.row.type === 1) ? _c('b-checkbox', {
            attrs: {
              "type": "is-info",
              "disabled": true
            },
            model: {
              value: (props.row.edit),
              callback: function($$v) {
                _vm.$set(props.row, "edit", $$v)
              },
              expression: "props.row.edit"
            }
          }) : _vm._e()], 1)]
        }
      }])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-5 has-text-centered"
    }, [_vm._v("Room fields values:")]), _vm._v(" "), (conf.roomfieldsview.length) ? _c('b-table', {
      staticStyle: {
        "overflow": "auto",
        "background": "#fafafa"
      },
      attrs: {
        "data": _vm.bodyRooms(conf.roomfieldsview),
        "columns": _vm.headRooms(conf.roomfieldsview),
        "width": "500"
      }
    }) : _vm._e()], 1)
  }))]) : _vm._e()], 1), _vm._v(" "), (!_vm.loading) ? _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$parent.close()
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.errors.length) ? _c('button', {
    staticClass: "button is-info ",
    on: {
      "click": function($event) {
        _vm.isConfirm = true
      }
    }
  }, [_vm._v("Data is correct. Import fields")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isConfirm,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isConfirm = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-card",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "modal-card-title"
  }, [_vm._v("Choose import variant\n\n        ")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('b-radio', {
    attrs: {
      "native-value": "1",
      "type": "is-info",
      "checked": ""
    },
    model: {
      value: (_vm.importType),
      callback: function($$v) {
        _vm.importType = $$v
      },
      expression: "importType"
    }
  }, [_vm._v("\n            Replace existing configuration fields, rooms, rooms fields, clients custom fields\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-radio', {
    attrs: {
      "native-value": "2",
      "type": "is-danger"
    },
    model: {
      value: (_vm.importType),
      callback: function($$v) {
        _vm.importType = $$v
      },
      expression: "importType"
    }
  }, [_vm._v("\n            Delete existing configuration fields, rooms, rooms fields, clients custom fields and save new\n          ")])], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isConfirm = false
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half has-text-right"
  }, [(!_vm.errors.length) ? _c('button', {
    staticClass: "button is-info ",
    on: {
      "click": _vm.importFileds
    }
  }, [_vm._v("Import")]) : _vm._e()])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b5851e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/mini_components/Importfields.vue
// module id = 317
// module chunks = 2